import { gql } from "@uplift-ltd/apollo";
import { AUTHOR_INFO_FRAGMENT } from "components/courses/fragments";

export const COURSE_AUTHOR_QUERY = gql`
  query CourseAuthorQuery($id: ID!, $idType: CourseAuthorIdType!) {
    courseAuthor(id: $id, idType: $idType) {
      id
      ...AuthorInfoFragment
      content
      seo {
        title
        metaDesc
        metaKeywords
        canonical
        opengraphImage {
          id
          mediaItemUrl
        }
      }
      courses {
        id
        title
        slug
      }
      featuredImage {
        node {
          id
          mediaDetails {
            height
            width
          }
          mediaItemUrl
        }
      }
    }
  }
  ${AUTHOR_INFO_FRAGMENT}
`;
